import React from 'react';
import { Svg, Path } from '../../hybrid/wrappers';

const SvgSpriteRank = ({ name, dataStyles }) => {
    switch (name) {
        case 'rank0':
            return (
                <Svg {...dataStyles} viewBox='0 0 56 56' xmlns='http://www.w3.org/2000/svg'>
                    <g clipPath='url(#clip0_1384_297358)'>
                        <circle cx='28' cy='28' r='28' fill='white' />
                        <path
                            d='M28.0001 0C12.5359 0 0 12.5359 0 28.0001C0 34.7386 2.38171 40.9212 6.34775 45.7525C6.95962 40.8532 11.853 36.7096 18.7147 34.7472C21.2215 37.0829 24.4595 38.5001 27.9999 38.5001C31.4571 38.5001 34.6317 37.1543 37.113 34.9166C44.0339 37.0504 48.8222 41.4362 48.9796 46.5339C53.3447 41.5958 56 35.1098 56 28.0001C56 12.5359 43.4641 0 28.0001 0ZM28.0001 35.1842C26.2126 35.1842 24.5284 34.6931 23.0328 33.8426C19.4288 31.7918 16.9473 27.5951 16.9473 22.7499C16.9473 15.8936 21.9054 10.3154 28.0001 10.3154C34.0953 10.3154 39.0528 15.8936 39.0528 22.7499C39.0528 27.6695 36.4937 31.918 32.8 33.9332C31.3449 34.7266 29.7212 35.1842 28.0001 35.1842Z'
                            fill='#8F8FAB'
                            fillOpacity='0.4'
                        />
                    </g>
                    <defs>
                        <clipPath id='clip0_1384_297358'>
                            <rect width='56' height='56' fill='white' />
                        </clipPath>
                    </defs>
                </Svg>
            );
        case 'rank1':
            return (
                <Svg {...dataStyles} viewBox='0 0 34 34'>
                    <circle cx='17' cy='17' r='17' fill='#2AB974' />
                    <path
                        d='M22.5146 20.2013L23.4919 25.9612C23.6315 26.6997 22.9334 27.2905 22.2354 26.8474L17.349 24.189C17.0698 24.0413 16.7906 24.0413 16.5114 24.189L11.7646 26.8474C11.2062 27.1428 10.3685 26.6997 10.5081 25.9612L11.4854 20.2013C11.4854 19.9059 11.4854 19.6106 11.2062 19.4629L7.29708 15.4752C6.73863 14.8845 7.01785 13.9983 7.71591 13.9983L13.1607 13.1122C13.4399 13.1122 13.7192 12.8168 13.8588 12.6691L16.2321 7.49998C16.5114 6.90922 17.4886 6.76153 17.7679 7.49998L20.1412 12.6691C20.2808 12.9645 20.5601 13.1122 20.8393 13.1122L26.2841 13.9983C26.9821 14.146 27.2614 15.0322 26.7029 15.4752L22.6542 19.4629C22.5146 19.6106 22.375 19.9059 22.5146 20.2013Z'
                        fill='white'
                    />
                </Svg>
            );
        case 'rank2':
            return (
                <Svg {...dataStyles} viewBox='0 0 34 34'>
                    <circle cx='17' cy='17' r='17' fill='#36CAEB' />
                    <Path
                        fillRule='evenodd'
                        clipRule='evenodd'
                        d='M7.31348 22.0289V18.9573L17.0289 24.4862L26.6865 18.9573V22.0289L17.0289 27.5578L7.31348 22.0289Z'
                        fill='white'
                    />
                    <Path
                        opacity='0.4'
                        fillRule='evenodd'
                        clipRule='evenodd'
                        d='M7.31348 17.1144V14.0427L17.0289 19.5717L26.6865 14.0427V17.1144L17.0289 22.6433L7.31348 17.1144Z'
                        fill='white'
                    />
                    <Path
                        opacity='0.4'
                        fillRule='evenodd'
                        clipRule='evenodd'
                        d='M7.31348 12.1997V9.12811L17.0289 14.6571L26.6865 9.12811V12.1997L17.0289 17.7287L7.31348 12.1997Z'
                        fill='white'
                    />
                </Svg>
            );
        case 'rank3':
            return (
                <Svg {...dataStyles} viewBox='0 0 34 34'>
                    <circle cx='17' cy='17' r='17' fill='#435FC5' />
                    <Path
                        fillRule='evenodd'
                        clipRule='evenodd'
                        d='M7.31348 22.0289V18.9573L17.0289 24.4862L26.6865 18.9573V22.0289L17.0289 27.5578L7.31348 22.0289Z'
                        fill='white'
                    />
                    <Path
                        fillRule='evenodd'
                        clipRule='evenodd'
                        d='M7.31348 17.1144V14.0427L17.0289 19.5717L26.6865 14.0427V17.1144L17.0289 22.6433L7.31348 17.1144Z'
                        fill='white'
                    />
                    <Path
                        opacity='0.4'
                        fillRule='evenodd'
                        clipRule='evenodd'
                        d='M7.31348 12.1997V9.12811L17.0289 14.6571L26.6865 9.12811V12.1997L17.0289 17.7287L7.31348 12.1997Z'
                        fill='white'
                    />
                </Svg>
            );
        case 'rank4':
            return (
                <Svg {...dataStyles} viewBox='0 0 34 34'>
                    <circle cx='17' cy='17' r='17' fill='#A043C0' />
                    <Path
                        fillRule='evenodd'
                        clipRule='evenodd'
                        d='M7.31348 22.0289V18.9573L17.0289 24.4862L26.6865 18.9573V22.0289L17.0289 27.5578L7.31348 22.0289Z'
                        fill='white'
                    />
                    <Path
                        fillRule='evenodd'
                        clipRule='evenodd'
                        d='M7.31348 17.1144V14.0427L17.0289 19.5717L26.6865 14.0427V17.1144L17.0289 22.6433L7.31348 17.1144Z'
                        fill='white'
                    />
                    <Path
                        fillRule='evenodd'
                        clipRule='evenodd'
                        d='M7.31348 12.1997V9.12811L17.0289 14.6571L26.6865 9.12811V12.1997L17.0289 17.7287L7.31348 12.1997Z'
                        fill='white'
                    />
                </Svg>
            );
        case 'rank5':
            return (
                <Svg {...dataStyles} viewBox='0 0 34 34'>
                    <circle cx='17' cy='17' r='17' fill='#D94763' />
                    <Path
                        d='M17 34C26.3888 34 34 26.3888 34 17C34 7.61116 26.3888 0 17 0C7.61116 0 0 7.61116 0 17C0 26.3888 7.61116 34 17 34Z'
                        fill='url(#paint0_linear_8703:130403)'
                    />
                    <Path d='M10.4102 24.4335H23.7148V39.4563H10.4102V24.4335Z' fill='#D8DFE7' />
                    <Path d='M14.6377 24.4337H19.487V39.4565H14.6377V24.4337Z' fill='#EDF1F4' />
                    <Path
                        d='M27.6936 25.0646C27.6936 27.2108 26.0771 28.8519 23.9633 28.8519C22.0982 28.8519 20.606 27.4632 20.233 25.5696H13.7672C13.5185 27.337 12.0264 28.8519 10.0369 28.8519C8.04744 28.8519 6.30664 27.2108 6.30664 25.0646C6.30664 22.9185 7.92309 21.2774 10.0369 21.2774H23.839C25.9528 21.2774 27.6936 23.0448 27.6936 25.0646Z'
                        fill='white'
                    />
                    <Path
                        d='M20.8602 14.901L21.5443 19.2209C21.642 19.7748 21.1534 20.2178 20.6648 19.8855L17.2443 17.8917C17.0489 17.781 16.8534 17.781 16.658 17.8917L13.3352 19.8855C12.9443 20.1071 12.358 19.7748 12.4557 19.2209L13.1398 14.901C13.1398 14.6795 13.1398 14.4579 12.9443 14.3472L10.208 11.3564C9.81704 10.9134 10.0125 10.2488 10.5011 10.2488L14.3125 9.58416C14.508 9.58416 14.7034 9.36262 14.8011 9.25185L16.4625 5.37499C16.658 4.93192 17.342 4.82115 17.5375 5.37499L19.1989 9.25185C19.2966 9.47339 19.492 9.58416 19.6875 9.58416L23.4989 10.2488C23.9875 10.3595 24.183 11.0241 23.792 11.3564L20.958 14.3472C20.8602 14.4579 20.7625 14.6795 20.8602 14.901Z'
                        fill='white'
                    />
                </Svg>
            );
        case 'rank6':
            return (
                <Svg {...dataStyles} viewBox='0 0 34 34'>
                    <circle cx='17' cy='17' r='17' fill='#F98937' />
                    <mask id='mask0' maskUnits='userSpaceOnUse' x='0' y='0' width='34' height='34'>
                        <Path
                            d='M17 34C26.3888 34 34 26.3888 34 17C34 7.61116 26.3888 0 17 0C7.61116 0 0 7.61116 0 17C0 26.3888 7.61116 34 17 34Z'
                            fill='url(#paint0_linear)'
                        />
                    </mask>
                    <g mask='url(#mask0)'>
                        <Path d='M10.3564 24.4931H23.7678V39.6364H10.3564V24.4931Z' fill='#D8DFE7' />
                        <Path d='M14.6191 24.4931H19.5074V39.6364H14.6191V24.4931Z' fill='#EDF1F4' />
                        <Path
                            d='M27.7791 25.1293C27.7791 27.2927 26.1497 28.947 24.0189 28.947C22.1388 28.947 20.6348 27.5472 20.2587 25.6384H13.7411C13.4904 27.4199 11.9863 28.947 9.98089 28.947C7.97546 28.947 6.2207 27.2927 6.2207 25.1293C6.2207 22.966 7.85012 21.3117 9.98089 21.3117H23.8936C26.0244 21.3117 27.7791 23.0933 27.7791 25.1293Z'
                            fill='white'
                        />
                    </g>
                    <Path
                        d='M24.5395 10.3059C24.532 10.2578 24.5167 10.2107 24.4982 10.1654C24.494 10.1556 24.494 10.1456 24.4896 10.1356C24.4891 10.1351 24.4882 10.134 24.4879 10.1334C24.4879 10.1323 24.4874 10.1318 24.4868 10.1311L22.8179 6.58739C22.8141 6.57924 22.8069 6.57191 22.8024 6.56362C22.7966 6.55366 22.7947 6.5415 22.7883 6.53164C22.7756 6.51008 22.7582 6.4933 22.7432 6.47409C22.728 6.45432 22.7141 6.43299 22.6973 6.41548C22.6724 6.3895 22.6438 6.36733 22.6148 6.34572C22.5966 6.33135 22.5794 6.31545 22.5595 6.30379C22.5258 6.28348 22.4892 6.26896 22.4521 6.25509C22.4336 6.24804 22.4156 6.23726 22.3962 6.23187C22.3387 6.21565 22.2789 6.20639 22.217 6.20639H16.9654H12.3813C12.3229 6.20639 12.2664 6.21455 12.2113 6.22892C12.1921 6.23404 12.1745 6.24403 12.1556 6.25053C12.1218 6.26325 12.0872 6.27435 12.0556 6.29246C12.0353 6.30412 12.0188 6.31969 11.9999 6.33245C11.9728 6.35167 11.9447 6.37005 11.9206 6.39332C11.9036 6.41005 11.8901 6.42981 11.8749 6.44866C11.8571 6.46958 11.8362 6.48851 11.8217 6.51229L9.55521 10.0561C9.54678 10.0699 9.54277 10.0856 9.53512 10.1002C9.52863 10.1118 9.51785 10.1218 9.51218 10.1345C9.50623 10.1478 9.50596 10.1618 9.50029 10.1745C9.48813 10.207 9.47845 10.2394 9.4708 10.273C9.46514 10.2997 9.4603 10.3258 9.45753 10.3521C9.45435 10.3853 9.45463 10.4184 9.45629 10.4519C9.45836 10.4791 9.4603 10.506 9.46458 10.5325C9.47053 10.5651 9.4808 10.5957 9.49117 10.6271C9.50057 10.6539 9.509 10.6805 9.52162 10.7057C9.52577 10.7144 9.52757 10.7244 9.53171 10.7334C9.5436 10.7555 9.56116 10.7728 9.57572 10.7927C9.58733 10.81 9.59438 10.8282 9.60765 10.8436L16.458 18.9349C16.5762 19.0743 16.7532 19.1734 16.9297 19.1683C16.932 19.1683 16.9342 19.1694 16.9357 19.1694C16.9456 19.17 16.955 19.17 16.9649 19.17C16.9652 19.17 16.9652 19.17 16.9652 19.17C16.9652 19.17 16.9657 19.17 16.9663 19.17C17.0255 19.17 17.0836 19.1589 17.1395 19.144C17.1561 19.1388 17.171 19.1335 17.1876 19.1271C17.2289 19.1128 17.269 19.0934 17.3072 19.0707C17.3199 19.0632 17.3334 19.0558 17.3459 19.0474C17.391 19.0161 17.4333 18.9802 17.4699 18.9368L24.3906 10.8457C24.3994 10.8352 24.4044 10.8225 24.4122 10.8114C24.4232 10.7974 24.4371 10.7858 24.4465 10.77C24.4564 10.7544 24.4614 10.7368 24.4697 10.7201C24.4814 10.6987 24.4924 10.6771 24.501 10.6539C24.514 10.6201 24.5229 10.5859 24.5306 10.5516C24.5356 10.5283 24.5412 10.5062 24.5433 10.483C24.5478 10.4448 24.5461 10.4076 24.5433 10.3697C24.5417 10.3473 24.5427 10.3264 24.5395 10.3059Z'
                        fill='white'
                    />
                    <defs>
                        <linearGradient id='paint0_linear' x1='0' y1='0' x2='34' y2='34' gradientUnits='userSpaceOnUse'>
                            <stop stopColor='#FFE476' />
                            <stop offset='1' stopColor='#FFCC00' />
                        </linearGradient>
                    </defs>
                </Svg>
            );
        case 'rank7':
            return (
                <Svg {...dataStyles} viewBox='0 0 34 34'>
                    <circle cx='17' cy='17' r='17' fill='#FAB031' />
                    <mask id='mask0' maskUnits='userSpaceOnUse' x='0' y='0' width='34' height='34'>
                        <Path
                            d='M17 34C26.3888 34 34 26.3888 34 17C34 7.61116 26.3888 0 17 0C7.61116 0 0 7.61116 0 17C0 26.3888 7.61116 34 17 34Z'
                            fill='#FAB031'
                        />
                    </mask>
                    <g mask='url(#mask0)'>
                        <Path d='M10.3564 24.4931H23.7678V39.6364H10.3564V24.4931Z' fill='#D8DFE7' />
                        <Path d='M14.6191 24.4931H19.5074V39.6364H14.6191V24.4931Z' fill='#EDF1F4' />
                        <Path
                            d='M27.7791 25.1293C27.7791 27.2927 26.1497 28.947 24.0189 28.947C22.1388 28.947 20.6348 27.5472 20.2587 25.6384H13.7411C13.4904 27.4199 11.9863 28.947 9.98089 28.947C7.97546 28.947 6.2207 27.2927 6.2207 25.1293C6.2207 22.966 7.85012 21.3117 9.98089 21.3117H23.8936C26.0244 21.3117 27.7791 23.0933 27.7791 25.1293Z'
                            fill='white'
                        />
                    </g>
                    <Path
                        d='M23.3191 18H10.6811C10.1123 18 9.62437 17.6074 9.5204 17.0659L8.01997 9.25492C7.93181 8.79612 8.14055 8.33161 8.54716 8.08125C8.95393 7.8309 9.47687 7.84507 9.86853 8.11677L13.8809 10.9016L15.9307 6.65967C16.1249 6.25773 16.5418 6.00097 17 6.00097C17.4583 6.00097 17.8752 6.25773 18.0694 6.65967L20.1191 10.9016L24.1315 8.11677C24.5232 7.84492 25.0461 7.83082 25.4528 8.08125C25.8595 8.33161 26.0682 8.7962 25.98 9.25492L24.4796 17.0659C24.3759 17.6073 23.8879 18 23.3191 18Z'
                        fill='white'
                    />
                    <Path
                        d='M25.4529 8.08028C25.0462 7.82985 24.5233 7.84395 24.1315 8.11579L20.1192 10.9007L18.0695 6.6587C17.8752 6.25676 17.4584 6 17.0001 6V17.9991L23.3191 18C23.8879 18 24.3759 17.6073 24.4796 17.0659L25.98 9.25492C26.068 8.79612 25.8596 8.33063 25.4529 8.08028Z'
                        fill='white'
                    />
                    <Path
                        d='M24.1063 17.9991H9.89414C9.24211 17.9991 8.7135 17.4873 8.7135 16.8559C8.7135 16.2246 9.24211 15.7127 9.89414 15.7127H24.1063C24.7583 15.7127 25.287 16.2246 25.287 16.8559C25.287 17.4873 24.7583 17.9991 24.1063 17.9991Z'
                        fill='white'
                    />
                    <Path
                        d='M24.1063 15.7127L17 15.7128L17.0001 17.9991L24.1063 17.9991C24.7583 17.9991 25.287 17.4873 25.287 16.8559C25.287 16.2246 24.7583 15.7127 24.1063 15.7127Z'
                        fill='white'
                    />
                </Svg>
            );
        case 'rankPlug':
            return (
                <Svg {...dataStyles} viewBox='0 0 34 34' fill='none'>
                    <circle cx='17' cy='17' r='17' fill='#F0F1F5' />
                    <Path
                        d='M22.5146 20.2013L23.4919 25.9612C23.6315 26.6997 22.9334 27.2905 22.2354 26.8474L17.349 24.189C17.0698 24.0413 16.7906 24.0413 16.5114 24.189L11.7646 26.8474C11.2062 27.1428 10.3685 26.6997 10.5081 25.9612L11.4854 20.2013C11.4854 19.9059 11.4854 19.6106 11.2062 19.4629L7.29708 15.4752C6.73863 14.8845 7.01785 13.9983 7.71591 13.9983L13.1607 13.1122C13.4399 13.1122 13.7192 12.8168 13.8588 12.6691L16.2321 7.49998C16.5114 6.90922 17.4886 6.76153 17.7679 7.49998L20.1412 12.6691C20.2808 12.9645 20.5601 13.1122 20.8393 13.1122L26.2841 13.9983C26.9821 14.146 27.2614 15.0322 26.7029 15.4752L22.6542 19.4629C22.5146 19.6106 22.375 19.9059 22.5146 20.2013V20.2013Z'
                        fill='#435FC5'
                    />
                </Svg>
            );
        case 'rankNoRang':
            return (
                <Svg {...dataStyles} viewBox='0 0 34 34' fill='none'>
                    <Path
                        d='M17 0C7.61116 0 0 7.61116 0 17C0 17.0289 7.20605e-05 17.0578 0.000216012 17.0866C0.0204693 21.1442 1.46304 24.8657 3.85399 27.7783C4.22549 24.8038 7.19647 22.288 11.3625 21.0965C12.8845 22.5146 14.8504 23.3751 16.9999 23.3751C19.0989 23.3751 21.0264 22.558 22.5329 21.1994C26.7349 22.4949 29.642 25.1577 29.7376 28.2527C32.0276 25.6622 33.5426 22.37 33.9122 18.7382C33.9479 18.3871 33.9729 18.0329 33.9868 17.6758C33.9956 17.4517 34 17.2263 34 17C34 7.61116 26.3888 0 17 0ZM17.0001 21.3619C15.9148 21.3619 14.8922 21.0637 13.9842 20.5473C12.8331 19.8923 11.8706 18.8767 11.2168 17.6329C10.6279 16.5124 10.2895 15.2066 10.2895 13.8124C10.2895 9.64971 13.2997 6.26293 17.0001 6.26293C20.7007 6.26293 23.7107 9.64971 23.7107 13.8124C23.7107 15.4409 23.2488 16.9482 22.4653 18.1807C21.8117 19.2089 20.9343 20.0458 19.9143 20.6023C19.0308 21.084 18.045 21.3619 17.0001 21.3619Z'
                        fill='#D1D7E2'
                    />
                </Svg>
            );

        default:
            return null;
    }
};

export default SvgSpriteRank;
